module.exports = __webpack_public_path__ + "static/media/icone-appStore.0f85bec7.svg";